/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteMessageForSelf.defs.js'
export * as $defs from './deleteMessageForSelf.defs.js'
